import React from 'react';
import padelMvpLogo from '../../assets/padelmvp_horizontal.svg';
import ModalCloseButton from './ModalCloseButton';

/**
 * AuthModal - Modal dialog for Sign In with Google and Email Link
 */
export default function AuthModal({
  isOpen,
  onClose,
  handleGoogleSignIn,
  handleEmailSignIn,
  emailForSignIn,
  setEmailForSignIn,
  emailLinkSent,
  emailLinkError,
  isEmailLinkSignIn,
  onCompleteEmailLinkSignIn
}) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal" role="dialog" aria-modal="true" aria-label="Sign in">
        <ModalCloseButton onClick={onClose} />

        {/* Header */}
        <img src={padelMvpLogo} alt="Padel MVP" width="168" height="32" className="auth-modal__logo" />
        <h3 className="modal-title">{isEmailLinkSignIn ? 'Complete sign in' : 'Sign in'}</h3>
        <p className="modal-subtitle">Access your clubs, matches, and real-time stats</p>

        {/* Google Sign In */}
        {!isEmailLinkSignIn && (
          <>
            <button type="button" onClick={() => handleGoogleSignIn()} className="btn btn-full auth-modal__google">
              <svg className="w-5 h-5" viewBox="0 0 24 24">
                <path
                  fill="#4285F4"
                  d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                />
                <path
                  fill="#34A853"
                  d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                />
                <path
                  fill="#FBBC05"
                  d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z"
                />
                <path
                  fill="#EA4335"
                  d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z"
                />
              </svg>
              <span>Continue with Google</span>
            </button>

            <div className="auth-modal__divider">
              <span>Or email</span>
            </div>
          </>
        )}

        {/* Email Sign In */}
        <input
          type="email"
          placeholder="Enter your email address"
          value={emailForSignIn}
          onChange={(e) => setEmailForSignIn(e.target.value)}
          className="input w-full"
        />

        <div className="modal-actions">
          {isEmailLinkSignIn ? (
            <button type="button" onClick={onCompleteEmailLinkSignIn} className="btn btn-primary btn-full">
              <span className="btn-text">Complete sign in</span>
            </button>
          ) : (
            <button type="button" onClick={handleEmailSignIn} className="btn btn-secondary btn-full">
              <span className="btn-text">Send sign-in link</span>
            </button>
          )}

          {emailLinkSent && (
            <p className="auth-modal__notice">✉️ Check your email inbox for your instant sign-in link!</p>
          )}

          {emailLinkError && (
            <p className="auth-modal__notice auth-modal__notice--error">{emailLinkError}</p>
          )}
        </div>
      </div>
    </div>
  );
}
